import React from 'react';
import Link from 'react-router/lib/Link';
import './ProductCard.less';

function ProductCard({data: {img, title, description, to}, first}) {
  return (
    <Link className='ProductCard' to={to} data-first={first ? true : null}>
      <div>
        <img src={img} alt='product'/>
      </div>
      <div>
        <h2>{title}</h2>
        <div>{description}</div>
      </div>
    </Link>
  );
}

export default ProductCard;


// WEBPACK FOOTER //
// ./src/routes/About/ProductCard.js